import { MEDIA_QUERIES } from '../utils/breakpoints.js';

export function initCommonFunctions() {
    const mqPc = window.matchMedia(MEDIA_QUERIES.pc);

    //faq
    (()=>{
        let faq = $(".js-faq");
        let faqAccordionTrigger = faq.find(".modFaq__item__question");

        faqAccordionTrigger.on("click", function(){
            $(this).toggleClass("is-active");
            $(this).next().slideToggle();
        })
        
    })();

    //Profile Card
    (()=>{
        let profileCard = $(".modProfileCard").not("[isFull], .modProfileCard--full");

        const checkProfileCardHeight = () => {
            if (mqPc.matches) {
                profileCard.removeClass("is-collapsed is-expanded");
                return;
            }
            profileCard.each(function(){
                let $this = $(this);
                if ($this.hasClass("is-expanded")) return;
                
                // Use scrollHeight to measure natural content height even when collapsed
                if ($this[0].scrollHeight > 900) {
                    $this.addClass("is-collapsed");
                } else {
                    $this.removeClass("is-collapsed");
                }
            });
        };

        profileCard.each(function(){
            let $this = $(this);
            let seeMoreBtn = $this.find(".js-profileCardMoreBtn");
            
            seeMoreBtn.on("click", function(){
                if(mqPc.matches) return;

                const $card = $(this).closest(".modProfileCard");
                const isExpanded = $card.hasClass("is-expanded");
                
                if (!isExpanded) {
                    const startHeight = $card.outerHeight();
                    $card.removeClass("is-collapsed").addClass("is-expanded");
                    
                    gsap.fromTo($card, 
                        { height: startHeight, overflow: "hidden" }, 
                        { 
                            height: "auto", 
                            duration: 0.6, 
                            ease: "power3.inOut",
                            clearProps: "height,overflow"
                        }
                    );
                } else {
                    const startHeight = $card.outerHeight();
                    $card.removeClass("is-expanded").addClass("is-collapsed");
                    
                    gsap.fromTo($card, 
                        { maxHeight: startHeight, overflow: "hidden" }, 
                        { 
                            maxHeight: 875, 
                            duration: 0.6, 
                            ease: "power3.inOut",
                            clearProps: "maxHeight,overflow"
                        }
                    );
                }
            })
        })

        $(window).on("load scroll resize", checkProfileCardHeight);
        checkProfileCardHeight();

        mqPc.addEventListener("change", function(){
            checkProfileCardHeight();
        })  
    })();

    //anchor
    (function(){
        let anchorLinks = document.querySelectorAll('a[href^="#"]');
        anchorLinks.forEach((link) => {
            link.addEventListener("click", (e) => {
                const href = link.getAttribute('href');
                
                if (href === '#' || href === '') {
                    e.preventDefault();
                    return;
                }
    
                const targetId = href.substring(1);
                const targetElement = document.getElementById(targetId);
    
                if (targetElement) {
                    e.preventDefault();
                    targetElement.scrollIntoView({
                        // behavior: 'smooth'
                    });
                }
            });
        });
    })();


    
}
